import { MuiTelInput } from "mui-tel-input";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectCurrentAgent } from "../../redux/features/authSlice";
import { PAKISTAN_ID, UAE_ID } from "../../constants/countries";

const countries = {
  [PAKISTAN_ID]: "PK",
  [UAE_ID]: "AE",
};

const PhoneInput = ({ name, rules, label }) => {
  const { control } = useFormContext();
  const currentAgent = useSelector(selectCurrentAgent);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...field }, fieldState: { error } }) => {
        return (
          <MuiTelInput
            size="small"
            fullWidth
            label={label}
            onlyCountries={["AE", "PK"]}
            defaultCountry={countries[currentAgent.countryid] || "AE"}
            error={!!error}
            focusOnSelectCountry
            forceCallingCode
            disableFormatting
            helperText={error?.message}
            {...field}
            inputRef={ref}
          />
        );
      }}
    />
  );
};

export default PhoneInput;
